import * as yup from "yup";
import { t } from "i18next";
import { getStringValidationRequired } from "@/shared/yup";
import { CONFIRM_EMAIL_CODE_LENGTH } from "./constants";

export const getProfileSchema = () => {
  return yup.object().shape({
    firstName: yup.string(),
    secondName: yup.string(),
    lastName: yup.string(),
    birthday: yup.mixed().nullable(),
    mobilePhone: yup.string(),
    email: yup.string(),
    confirmEmailCode: getStringValidationRequired()
      .min(CONFIRM_EMAIL_CODE_LENGTH, t("validation.minLength", { min: CONFIRM_EMAIL_CODE_LENGTH }))
      .max(
        CONFIRM_EMAIL_CODE_LENGTH,
        t("validation.maxLength", { max: CONFIRM_EMAIL_CODE_LENGTH }),
      ),
  });
};
